<template>
  <div class="addFieldBtn">
    <a href="javascript:void(0)" @click="addFild" v-if="$route.query.status !== 'true'"><i class="icon-addfield"></i>添加字段</a>
    <!-- 添加字段弹窗 -->
    <el-dialog title="" :visible.sync="visibility" :modal="true" :close-on-click-modal="true" class="commonDialog addDialog" :append-to-body="true" width="32%" ref="addDialog" @close="addCancelDialog">
      <div slot="title">
        <span class="title">添加字段</span>
      </div>
      <div class="content">
        <div class="top">
          <ul>
            <li v-for="(item,index) in addFiledsData" :key="index">
              <div class="row">
                <div class="filedKey">字段名称</div>
                <el-input v-model="item.title" placeholder="填写需要展示的字段名"></el-input>
                <div class="handleRow">
                  <i v-if="index!==0" class="el-icon-close" @click="minusRow(index)"></i>
                </div>
              </div>
              <div class="sm" v-if="index===addFiledsData.length-1">字段名称支持填写中文，英文，不支持特殊符号</div>
            </li>
          </ul>
          <a href="javascript:void(0)" @click="addRow(index)" class="addField"><i class="el-icon-circle-plus-outline"></i>添加字段名称</a>
        </div>
        <div class="footer">
          <el-button type="primary" class="cancel" @click="cancelDialog">取&nbsp;&nbsp;消</el-button>
          <el-button type="primary" class="confirm" @click="confirmDialog">确&nbsp;&nbsp;定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'

import _ from 'lodash'

import bus from '@/assets/js/bus'
import busType from '@/assets/js/busType'

export default {
  name: 'addFieldBtn',
  mixins: [],
  props: {},
  data() {
    return {
      visibility: false,
      addFiledsData: [
        {
          title: ''
        }
      ]
    }
  },
  computed: {
    ...mapState(['labelState']),
    ...mapGetters(['editTemplate'])
  },
  components: {},
  watch: {},
  mounted() {},
  methods: {
    addFild() {
      this.visibility = true
    },
    addCancelDialog() {
      this.visibility = false
      this.addFiledsData = [
        {
          title: ''
        }
      ]
    },
    cancelDialog() {
      this.visibility = false
    },
    confirmDialog() {
      if (
        this.addFiledsData.length === 1 &&
        this.addFiledsData[0].title.trim() === ''
      ) {
        this.$message.error('字段名称不能为空')
        return
      }

      let ary = []

      this.addFiledsData.forEach(item => {
        let title = item.title

        // this.editTemplate.ruleMap[key] = {
        //     fieldRuleList: [_.defaults({
        //         title:title
        //     }, this.$utils.defaultRule)],
        //     fieldFilterRule: this.$utils.defaultFilterRule,
        //     title:title
        // }

        ary.push({
          fieldRuleList: [
            _.defaults(
              {
                title: title
              },
              this.$utils.defaultRule
            )
          ],
          fieldFilterRule: this.$utils.defaultFilterRule,
          addField: true
        })
      })

      this.saveField(ary)
    },
    saveField(ary) {
      let url = this.$resource.editTemplate.replace(
        '{templateId}',
        this.editTemplate.templateId
      )

      this.$axios({
        url: url,
        method: 'put',
        data: ary
      })
        .then(res => {
          this.$message.success('添加成功')

          // =>EditPage.vue
          bus.$emit(busType.RESETINDENTITY, 'AddFiedBtn')

          this.$parent.closeCollapse()

          this.visibility = false
        })
        .catch(e => {
          console.log(e)
        })
    },
    addRow(index) {
      this.addFiledsData.push({
        title: ''
      })
    },
    minusRow(index) {
      this.addFiledsData.splice(index, 1)
    }
  }
}
</script>
<style>
.addFieldBtn {
  height: 52px;
  line-height: 52px;
  border-bottom: 1px solid #e8e8e8;
  padding-left: 30px;

  a {
    color: var(--color-title);
  }

  .icon-addfield {
    margin-right: 6px;
  }
}
</style>